import React from 'react';
import { useToasts } from 'react-toast-notifications';

const useCustomToast = () => {
  const { addToast, ...rest } = useToasts();

  const baseText = (content) => {
    const styles = {
      width: '100%',
      fontWeight: 'bold',
      fontSize: '20px',
      paddingTop: '1rem',
      paddingBottom: '1rem',
      paddingRight: '0 !important',
      marginRight: '0 !important',
    };

    if (typeof content === 'string') {
      return <div className="font-source-sans-regular" style={styles} dangerouslySetInnerHTML={{ __html: content }} />;
    }

    return (
      <div className="font-source-sans-regular" style={styles}>
        {content}
      </div>
    );
  };

  const baseToast = (content, type, extraProps = {}) => {
    addToast(baseText(content), { ...extraProps, appearance: type });
  };

  return {
    ...rest,
    addSuccessToast: (content, extraProps) => baseToast(content, 'success', extraProps),
    addErrorToast: (content, extraProps) => baseToast(content, 'error', extraProps),
    addWarningToast: (content, extraProps) => baseToast(content, 'warning', extraProps),
    addInfoToast: (content, extraProps) => baseToast(content, 'info', extraProps),
  };
};

export default useCustomToast;
